/**
 * Tiny client for /api/gmat/* endpoints — handles cookies + JSON.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

const request = async (method, path, body) => {
  const opts = { method, credentials: 'include', headers: {} };
  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${BACKEND_URL}${path}`, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.detail || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
};

export const gmatApi = {
  authMe: () => request('GET', '/api/gmat/auth/me'),
  authExchange: async (sessionId) => {
    const res = await fetch(`${BACKEND_URL}/api/gmat/auth/exchange`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-Session-ID': sessionId },
    });
    if (!res.ok) throw new Error(`Auth exchange failed (${res.status})`);
    return res.json();
  },
  authLogout: () => request('POST', '/api/gmat/auth/logout'),

  dashboard: () => request('GET', '/api/gmat/dashboard'),

  practiceNext: (body) => request('POST', '/api/gmat/practice/next', body),
  practiceSubmit: (body) => request('POST', '/api/gmat/practice/submit', body),

  mockStart: (body) => request('POST', '/api/gmat/mock/start', body),
  mockAvailability: () => request('GET', '/api/gmat/mock/availability'),
  mockQuestion: (sid, qid) => request('GET', `/api/gmat/mock/${sid}/question/${qid}`),
  mockFinalize: (sid) => request('POST', `/api/gmat/mock/${sid}/finalize`),

  // Admin
  adminListQuestions: (qs = '') => request('GET', `/api/gmat/admin/questions${qs}`),
  adminAddQuestion: (body) => request('POST', '/api/gmat/admin/questions', body),
  adminUpdateQuestion: (id, body) => request('PATCH', `/api/gmat/admin/questions/${id}`, body),
  adminDeleteQuestion: (id) => request('DELETE', `/api/gmat/admin/questions/${id}`),
  adminBulkUpload: (questions) => request('POST', '/api/gmat/admin/questions/bulk-upload', { questions }),
  adminSeedFromFile: () => request('POST', '/api/gmat/admin/questions/seed-from-file'),
  adminStudents: () => request('GET', '/api/gmat/admin/students'),
};

export const goToGoogleAuth = (nextPath) => {
  // Per Emergent Google Auth playbook — never hardcode the URL.
  // We embed the intended destination as `?next=...` on the redirect URL so
  // GmatProfilePage knows where to land after the session exchange.
  // We also stash it in sessionStorage as a defensive backup.
  const safeNext = typeof nextPath === 'string' && nextPath.startsWith('/') ? nextPath : '';
  if (safeNext) {
    try { sessionStorage.setItem('gmat_post_login_next', safeNext); } catch (e) { /* ignore */ }
  }
  const redirectUrl = `${window.location.origin}/gmat/profile${safeNext ? `?next=${encodeURIComponent(safeNext)}` : ''}`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
